import React from 'react';

export const ElectronicSignaturePage = () => {
  return <>E-Sign</>;
};
